import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PrizeNavigation from "../components/PrizeNavigation";
import AddMembers from "../components/AddMembers";
import styles from './InviteMembers.module.css';
import addUserLeagueAssociation from '../utils/addUserLeagueAssociationHelper'; // Import the helper function
import { useUser } from '../UserContext';
import { sendInviteEmails } from '../utils/inviteService';
import API_BASE_URL from '../utils/apiConfig';


const InviteMembers = () => {
  const [members, setMembers] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  // Retrieve the league name and sport from the league setup page
  const { leagueName, sport } = location.state || {};
  // Retrieve the user from the UserContext
  const { user } = useUser();
  const token = user?.token; // Safely extract the JWT token
  const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;


  const handleAddMember = (newMembers) => {
    setMembers((prevMembers) => [...prevMembers, ...newMembers]);
  };

  const handleSaveMembers = async (updatedMembers) => {
    try {
    // Get commissioner data from user context
    const commissioner = {
      userId: user._id,
      role: 'commissioner',
      name: user.userName || user.name,  // Add name
      email: user.email                  // Add email
    };

    // Combine commissioner with other members
    const allMembers = [
    {
      userId: user._id,
      role: "commissioner",
      name: user.userName || user.name,
      email: user.email,
    },
    ...updatedMembers.map((member) => ({
      userId: member.userId || null,
      role: member.role || "member",
      name: member.name || "",
      email: member.email || "",
    })),
  ];

    const requestData = {
      leagueName,
      sport,
      members: allMembers,
      leagueCommissioner: user._id
    };

      // POST request to create the league
      const response = await fetch(`${API_BASE_URL}/api/leagues`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        // Not successful - the backend responded with an error status
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create league");
      }

      // Parse the response to get the created league
      const data = await response.json();
      const leagueId = data.league._id;

      // Send invite emails to members only (exclude commissioner)
      const invitees = updatedMembers.map((member) => ({
        to: member.email,
        name: member.name,
        league_name: leagueName,
        action_url: `${FRONTEND_BASE_URL}/createaccount?redirect=/commissionerdash/${leagueId}`,
      }));

      await sendInviteEmails(invitees,); // dryun flag controlled by backend env

      // Navigate to the commissioner dashboard with a success message
      navigate("/commissionerdash", { state: { message: "League created successfully!" } });

    } catch (error) {
      console.error("Error creating league:", error);
      // Navigate to the commissioner dashboard with an error message
      navigate("/commissionerdash", { state: { message: error.message || "Something went wrong. Please try again." } });
    }
  };

  return (
    <div className={styles.invitemembers}>
      <PrizeNavigation navigationButtonArea="/2813821-1@2x.png" />
      <p className={styles.leagueName}>Setup your league - step 2 of 2</p>

      <section className={styles.invitemembersInner}>
        {/* Pass 'isModal={false}' since we're not using AddMembers as a modal here */}
        <AddMembers
          isModal={false}
          onSave={(newMembers) => {
            handleAddMember(newMembers); // Update the members state in InviteMembers
            handleSaveMembers([...members, ...newMembers]); // Pass the combined array directly
          }}
        />
      </section>
    </div>
  );
};

export default InviteMembers;
